/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect } from "react";
import { NavLink } from "react-router-dom";
import { shallowEqual, useSelector } from "react-redux";
import { Dropdown, OverlayTrigger, Tooltip } from "react-bootstrap";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../../_metronic/_helpers";
import {
  DropdownCustomToggler,
  DropdownMenu4,
} from "../../../../_metronic/_partials/dropdowns";

export function ProfileCard() {
  const user = useSelector(({ auth }) => auth.user, shallowEqual);

  useEffect(() => {
    return () => {};
  }, [user]);

  return (
    <>
      {user && (
        <div
          className="flex-row-auto offcanvas-mobile w-300px w-xxl-350px"
          id="kt_profile_aside"
        >
          <div className="card card-custom card-stretch">
            {/* begin::Body */}
            <div className="card-body pt-4">
              {/* begin::Toolbar */}
              {/* begin::User */}
              <div className="d-flex align-items-center">

                <div>
                  <a
                    href="#"
                    className="font-weight-bolder font-size-h5 text-dark-75 text-hover-primary"
                  >
                    {user.name}
                  </a>
                  <div className="text-muted">{user.phone}</div>
                </div>
              </div>
              {/* end::User */}
              {/* begin::Contact */}
              {/* end::Contact */}
              {/* begin::Nav */}
              <div className="navi navi-bold navi-hover navi-active navi-link-rounded mt-4">
                {/*<div className="navi-item mb-2">*/}
                {/*  <NavLink*/}
                {/*    to="/user-profile/profile-overview"*/}
                {/*    className="navi-link py-4"*/}
                {/*    activeClassName="active"*/}
                {/*  >*/}
                {/*    <span className="navi-icon mr-2">*/}
                {/*      <span className="svg-icon">*/}
                {/*        <SVG*/}
                {/*          src={toAbsoluteUrl(*/}
                {/*            "/media/svg/icons/Design/Layers.svg"*/}
                {/*          )}*/}
                {/*        ></SVG>{" "}*/}
                {/*      </span>*/}
                {/*    </span>*/}
                {/*    <span className="navi-text font-size-lg">*/}
                {/*      Profile Overview*/}
                {/*    </span>*/}
                {/*  </NavLink>*/}
                {/*</div>*/}
                {/*<div className="navi-item mb-2">*/}
                {/*  <NavLink*/}
                {/*    to="/user-profile/personal-information"*/}
                {/*    className="navi-link py-4"*/}
                {/*    activeClassName="active"*/}
                {/*  >*/}
                {/*    <span className="navi-icon mr-2">*/}
                {/*      <span className="svg-icon">*/}
                {/*        <SVG*/}
                {/*          src={toAbsoluteUrl(*/}
                {/*            "/media/svg/icons/General/User.svg"*/}
                {/*          )}*/}
                {/*        ></SVG>{" "}*/}
                {/*      </span>*/}
                {/*    </span>*/}
                {/*    <span className="navi-text font-size-lg">*/}
                {/*      Personal Information*/}
                {/*    </span>*/}
                {/*  </NavLink>*/}
                {/*</div>*/}
                {/*<div className="navi-item mb-2">*/}
                {/*  <NavLink*/}
                {/*    to="/user-profile/account-information"*/}
                {/*    className="navi-link py-4"*/}
                {/*    activeClassName="active"*/}
                {/*  >*/}
                {/*    <span className="navi-icon mr-2">*/}
                {/*      <span className="svg-icon">*/}
                {/*        <SVG*/}
                {/*          src={toAbsoluteUrl(*/}
                {/*            "/media/svg/icons/Code/Compiling.svg"*/}
                {/*          )}*/}
                {/*        ></SVG>{" "}*/}
                {/*      </span>*/}
                {/*    </span>*/}
                {/*    <span className="navi-text font-size-lg">*/}
                {/*      Account Information*/}
                {/*    </span>*/}
                {/*  </NavLink>*/}
                {/*</div>*/}
                {/*<div className="navi-item mb-2">*/}
                {/*  <NavLink*/}
                {/*    to="/user-profile/change-password"*/}
                {/*    className="navi-link py-4"*/}
                {/*    activeClassName="active"*/}
                {/*  >*/}
                {/*    <span className="navi-icon mr-2">*/}
                {/*      <span className="svg-icon">*/}
                {/*        <SVG*/}
                {/*          src={toAbsoluteUrl(*/}
                {/*            "/media/svg/icons/Communication/Shield-user.svg"*/}
                {/*          )}*/}
                {/*        ></SVG>{" "}*/}
                {/*      </span>*/}
                {/*    </span>*/}
                {/*    <span className="navi-text font-size-lg">*/}
                {/*      تغییر رمز عبور*/}
                {/*    </span>*/}
                {/*  </NavLink>*/}
                {/*</div>*/}
                <div className="navi-item mb-2">
                  <NavLink
                      to="/user-profile/wallet"
                      className="navi-link py-4"
                      activeClassName="active"
                  >
                    <span className="navi-icon mr-2">
                      <span className="svg-icon">
                        <SVG
                            src={toAbsoluteUrl(
                                "/media/svg/icons/Shopping/Money.svg"
                            )}
                        ></SVG>{" "}
                      </span>
                    </span>
                    <span className="navi-text font-size-lg">
                      کیف پول من
                    </span>
                  </NavLink>
                </div>
              </div>
              {/* end::Nav */}
            </div>
            {/* end::Body */}
          </div>
        </div>
      )}
    </>
  );
}
